'use client'

import { type Maybe } from '@/lib/generated/graphql'
import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

export const GTMSearchEvent = ({
  searchTerm,
  event,
}: {
  searchTerm: string
  event: string
}) => {
  useEffect(() => {
    sendGTMEvent({
      event,
      search_term: searchTerm,
    })
  }, [searchTerm, event])
  return <></>
}

interface FilterData {
  category: Maybe<string[]> | undefined
  sub_category: Maybe<string> | undefined
  retailerId: Maybe<string[]> | undefined
  discount: Maybe<number> | undefined
  priceMin: Maybe<number> | undefined
  priceMax: Maybe<number> | undefined
  type: Maybe<string> | undefined
  brandName: Maybe<string[]> | undefined
  sort: Maybe<string> | undefined
}

export const GTMFilterEvent = ({
  filterData,
  event,
}: {
  filterData: FilterData
  event: string
}) => {
  useEffect(() => {
    sendGTMEvent({
      event: 'filter_selection',
      section: {
        filters: filterData,
      },
    })
  }, [filterData])
  return <></>
}
